import * as React from "react";
import * as Immutable from "immutable";
import { DocumentTitle, Spinner } from "components/common";
import useRoles from "common/hooks/useRoles";
import ConfigSection from "./components/ConfigSection";
import GroupSyncSection from "./components/GroupSyncSection";
const BackendConfig = ({ authenticationBackend }) => {
  const { isLoading, roles } = useRoles();
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Okta Authentication Services" }, /* @__PURE__ */ React.createElement(ConfigSection, { authenticationBackend }), /* @__PURE__ */ React.createElement(GroupSyncSection, { authenticationBackend, roles: Immutable.List(roles) }));
};
export default BackendConfig;
